import React, { Component } from 'react';
import { Icon } from 'antd';

class NotificationSettings extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <p>
        <Icon type='tool' spin={true} style={{ fontSize: 16 }} /> Under Construction{' '}
      </p>
    );
  }
}

export default NotificationSettings;



// WEBPACK FOOTER //
// ./src/components/userSettings/NotificationSettings.js